import { render, staticRenderFns } from "./ExamStudentResult.vue?vue&type=template&id=47bd0020"
import script from "./ExamStudentResult.vue?vue&type=script&lang=js"
export * from "./ExamStudentResult.vue?vue&type=script&lang=js"
import style0 from "./ExamStudentResult.vue?vue&type=style&index=0&id=47bd0020&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports